<template>
  <div>
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {}
</script>

<style lang="stylus" rel="stylesheet/stylus">

.bottom {
  color: black;
}

.bottom-ul {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  position: relative;
}

.bottom-ul > li {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin 0 12px;
  cursor: pointer;
}

.active {
  background-color: yellow;
}

/*底部router-link 的激活样式切换*/
.router-link-active {
  color: #ffd400;
}

.bottom-ul > li > span {
  font-size: 0.50rem;
}
</style>
